exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#home[data-v-3d9a511f]{margin:0;padding:0}#home-container[data-v-3d9a511f]{margin-right:.25rem;margin-bottom:0}", "", {"version":3,"sources":["C:/Users/carlo/Development/webclient/src/components/Home/Home.vue"],"names":[],"mappings":"AACA,uBACE,SAAU,AACV,SAAW,CACZ,AACD,iCACE,oBAAqB,AACrB,eAAmB,CACpB","file":"Home.vue","sourcesContent":["\n#home[data-v-3d9a511f] {\n  margin: 0;\n  padding: 0;\n}\n#home-container[data-v-3d9a511f] {\n  margin-right: .25rem;\n  margin-bottom: 0px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3d9a511f","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Home/Home.vue
// module id = 970
// module chunks = 6